export enum TYPES {
  ACTION_DEFAULT = '@@calculadora/ACTION_DEFAULT',

  DEFAULT_SAGA = '@@calculadora/DEFAULT_SAGA'
}

export interface CALCULADORA {
  defaultValue: string
}
